module.exports = __webpack_public_path__ + "static/media/success-step.513d1e33.svg";